// Thin adapter over @learnzapp/core/articles for the metered unlock
// surfaces (web twin of mobile utils/articleAccess.js). Owns the two impurities
// the core keeps out (the brand flag and the clock) so every screen computes
// access the same way.
//
// METERED_ARTICLE_UNLOCKS == null → feature OFF: callers must keep the legacy
// first-num_articles-per-domain behavior (check isArticleMeteringEnabled()
// before consulting any of this).
import { deriveArticleAccess, getMeterState, getUnlockPeriodKey, meterPeriodCopy, resolveArticleOpenTarget as coreResolveArticleOpenTarget } from "@learnzapp/core/articles";
import { METERED_ARTICLE_UNLOCKS, METERED_ARTICLE_PERIOD } from "./brandFlags";

export const isArticleMeteringEnabled = () => METERED_ARTICLE_UNLOCKS != null;

export const currentUnlockPeriodKey = () => getUnlockPeriodKey(Date.now(), METERED_ARTICLE_PERIOD);

/** Period-dependent copy nouns for the surfaces ("today"/"this week",
 *  "resets daily"/"resets weekly", …) — pinned in core so apps can't drift. */
export const meterCopy = () => meterPeriodCopy(METERED_ARTICLE_PERIOD);

/** Access decision for one article. `articles` is AuthContext's articles state. */
export function getArticleAccess({ articleId, isSubscribe, isAuthenticated, articles, anonymousConsumedArticles }) {
  return deriveArticleAccess({
    articleId,
    isSubscribe,
    isAuthenticated,
    readMap: articles?.readMap ?? {},
    unlockMap: articles?.unlocks ?? {},
    consumedArticleIds: (anonymousConsumedArticles ?? []).map((s) => s.id),
    periodKey: currentUnlockPeriodKey(),
    limit: METERED_ARTICLE_UNLOCKS,
  });
}

/** Current period's meter state (used/remaining/limit) for pills and prompts. */
export function getArticleMeter(articles) {
  return getMeterState(articles?.unlocks ?? {}, currentUnlockPeriodKey(), METERED_ARTICLE_UNLOCKS);
}

/**
 * Openable pager list + index for a domain article — thin wrapper injecting
 * the brand flag into the golden-tested core definition (shared by the
 * articles landing and the Home nudge so openability can't drift).
 */
export function resolveArticleOpenTarget({ articles, domainList, domainId, articleId, isSubscribe }) {
  return coreResolveArticleOpenTarget({
    articles,
    domainList,
    domainId,
    articleId,
    isSubscribe,
    meteringEnabled: isArticleMeteringEnabled(),
  });
}
